import {
  nonClaimsModules,
  nonFastTrackModules
} from "../constants/SMEModulesToMatchOn";
import { shouldShowIfAllSMEModulesDontMatch } from "../helpers/SMEModules/smeModuleHelper";
import { _thumbNailGPAppointments } from "../content/Home";

export const mapStateToProps = state => {
  let selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;

  return {
    Layout: state.layoutReducer && state.layoutReducer.layout,
    CurrentPolicy: selectedPolicy,
    shouldShowFastTrack: shouldShowIfAllSMEModulesDontMatch(
      selectedPolicy,
      nonFastTrackModules
    ),
    shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
      selectedPolicy,
      nonClaimsModules
    )
  };
};

export const stripGP247 = (isChildOnlyPolicy, listItems) => {
  if (!isChildOnlyPolicy) {
    return listItems;
  }

  var result = listItems.filter(i => i.Heading !== _thumbNailGPAppointments.Heading);

  return result;
};